import React, { useRef, useState } from "react";
import { APPNAME, FORM_STEPS, KEYCLOAK_CLIENT_ID } from "../../../Utils/Constants";
import { URL_BASE, URL_IDEN } from "../../../services/servicesConstants";
import "./LoginFormBackend.css";
import { useTranslation } from "react-i18next";
import { MULTITENANT_CONSTANTS, TENANT } from "../../../Resources/Multitenant/tenantConstants";
import { initializeKeycloak } from "../../../Utils/keycloak";
import { userLoginActionCreator } from "../../../actions/commonActions";
import {useDispatch, useSelector} from "react-redux";
import AlertNotification from "../../../Components/GUI/Alert/Alert";
import { isCordovaAvailable, setTokensInSecureStorage } from "../../../Utils/secureStorageUtil";
import jwtDecode from "jwt-decode";
import { useEffect } from "react";
import {NavLink} from "react-router-dom";
import {URL_LOGIN} from "../../../Components/Routes/Location";

const loginService = (appname, body, callback, errorCallback) => {
  fetch(`${URL_BASE}${URL_IDEN}users/${appname}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  })
      .then((response) => response.json())
      .then((data) => callback({ data }))
      .catch((err) => errorCallback(err));
};

const LoginFormBackend = ({ tenantLanguages, changeFormStep, handleLogin, handleNavigateAsGuest }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  let timeoutId;
  const ERROR_TIME_IN_MILIS = 5000;

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  //const [rememberLogin, setRememberLogin] = useState(true);
  const [loginError, setLoginError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const cordovaAvailable = useRef(false);

  const tenantStyles = useSelector((state) => state.commonState.tenantStyles);

  useEffect(() => {
    cordovaAvailable.current = isCordovaAvailable();
    /*
    if (isCordovaAvailable() && !isSecureStorageInstantiated()) {
      setRememberLogin(false);
    }
    */
  }, []);

  // Almacenar tokens y nombre de usuario de forma segura en dispositivos móviles
  const setTokensAndUsernameInAndroid = async (token, refreshToken, username) => {
    if (cordovaAvailable.current) {
      await setTokensInSecureStorage(token, refreshToken, username);
      console.log("Tokens almacenados correctamente en SecureStorage");
    } else {
      throw new Error("Cordova no está disponible, no se puede almacenar información.");
    }
  };

  const languagesName = {
    es: t("lang.es"),
    gl: t("lang.gl"),
    eu: t("lang.eu"),
    en: t("lang.en"),
    ca: t("lang.ca"),
    vc: t("lang.vc"),
    pt: t("lang.pt"),
    fr: t("lang.fr"),
    jp: t("lang.jp"),
  };

  const setTokensAndUsername = async (token, refreshToken, username, remember = true) => {
    if (cordovaAvailable.current) {
      if (!remember) {
        return;
      }
      try {
        await setTokensAndUsernameInAndroid(token, refreshToken, username);
        setTokensAndUsernameInWeb(token, refreshToken, username, true);
      } catch (error) {
        console.error("Error al almacenar tokens en SecureStorage. Se usa fallback en localStorage:", error);
        setTokensAndUsernameInWeb(token, refreshToken, username, true);
      }
    } else {
      setTokensAndUsernameInWeb(token, refreshToken, username, remember);
    }
  };

  const setTokensAndUsernameInWeb = (token, refreshToken, username, remember = true) => {
    if (remember) {
      localStorage.setItem("access_token", token);
      localStorage.setItem("refresh_token", refreshToken);
      localStorage.setItem("username", username);
    } else {
      sessionStorage.setItem("access_token", token);
      sessionStorage.setItem("refresh_token", refreshToken);
      sessionStorage.setItem("username", username);
    }
  };

  const loginCallback = async (data) => {
    if (!!data?.data?.error_error) {
      loginErrorCallback(data.data);
      return;
    }
    if (data?.data?.access_token) {
      const { access_token, refresh_token } = data.data;
      const decoded = jwtDecode(access_token);
      const realUsername = decoded?.preferred_username || username.toLowerCase();
      await setTokensAndUsername(access_token, refresh_token, realUsername, true);
      initializeKeycloak(access_token, refresh_token, realUsername);
      dispatch(userLoginActionCreator(realUsername));
      handleLogin();
    } else {
      loginErrorCallback(data);
    }
  };

  const showErrorMessage = (errorText) => {
    clearTimeout(timeoutId);
    setLoginError(errorText);
    timeoutId = setTimeout(() => {
      setLoginError(null);
    }, ERROR_TIME_IN_MILIS);
  }

  const loginErrorCallback = (error) => {
    switch (error?.error_error?.http_status_code) {
      case 400:
        showErrorMessage(t('user.login.error.verification'));
        break;
      default:
      case 401:
        showErrorMessage(t('user.login.error.credentials'));
        break;
    }
  };

  const handleSubmit = (event) => {
    const client_id = KEYCLOAK_CLIENT_ID;
    const usernameLower = username.toLowerCase();
    loginService(APPNAME, { username: usernameLower, password, client_id }, loginCallback, loginErrorCallback);
    event.preventDefault();
  };

  const handleLanguageChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  const handleRegister = () => {
    if (!!MULTITENANT_CONSTANTS[TENANT]?.registerUrl) {
      window.location.href = MULTITENANT_CONSTANTS[TENANT].registerUrl;
    } else {
      changeFormStep(FORM_STEPS.REGISTER);
    }
  };

  /*
  const handleChangeRemember = (event) => {
    if (isCordovaAvailable() && !isSecureStorageInstantiated()) {
      showErrorMessage(t('user.login.error.secure_storage'));
    } else {
      setRememberLogin(event.target.checked)
    }
  }
    */

  return (
      <div
          className={"Register"}
          style={{
            "background-image": "url(" + tenantStyles?.backgroundRegister + ")",
          }}
      >
        <div className="App-container">
          <div className="Register-Container">
            <div className="logo">
              <NavLink to={URL_LOGIN}>
                <div className="Logo-Barra" alt="logo"/>
              </NavLink>
            </div>
            <h1 className={"Header-Title"}>{t("user.login")}</h1>
            <div  className={"DataUser"}>
            <div className={"WizardContainer"}>
              <form onSubmit={handleSubmit}>
                <div className="LanguageSelector">
                  <select value={i18n.language} onChange={handleLanguageChange}>
                    {tenantLanguages.map((lang) => (
                        <option key={lang} value={lang}>
                          {languagesName[lang]}
                        </option>
                    ))}
                  </select>
                </div>
                {loginError && (
                    <div className="ErrorBlock">
                      <AlertNotification type="error" time={ERROR_TIME_IN_MILIS} showtitle={false} text={loginError}/>
                    </div>
                )}
                <label className="campoForm UsernameBlock">
                  <input
                    className="InputUsuario"
                    type="text"
                    autoCapitalize="none"
                    autoCorrect="off"
                    spellCheck={false}  
                    placeholder={t("register.nomeusuario")}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </label>

                <label className="campoForm PasswordBlock">
                  <input
                      className="InputPassword"
                      type={showPassword ? "text" : "password"}
                      placeholder={t("register.datapassword")}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                  />
                  <button type="button" className="PasswordToggle" onClick={() => setShowPassword(!showPassword)}>
                    <ion-icon name={showPassword ? "eye-outline" : "eye-off-outline"} aria-label={showPassword ? t("password.hide") : t("password.show")}></ion-icon>
                  </button>
                </label>

                <div className="RememberRecoveryBlock">
                  {/*
          <label className="RememberBlock">
            <input
                type="checkbox"
                checked={rememberLogin}
                onChange={handleChangeRemember}
            />
            {t("user.login.remember")}
          </label>
          */}
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a className="RecoveryLink" onClick={() => changeFormStep(FORM_STEPS.RECOVER)}>
                    {t('user.login.recovery')}
                  </a>
                </div>

                <div className="ButtonGroup">
                  <button type="submit" className="LoginFormButton button">
                    {t('user.login.login')}
                  </button>
                  <button type="button" className="LoginFormButton button" onClick={handleRegister}>
                    {t('user.login.register')}
                  </button>
                </div>

                <div className="Separator"></div>

                <div className="NavigateAsGuestBlock">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a className="NavigateAsGuestButton" onClick={handleNavigateAsGuest}>
                    {t('user.login.navigate_as_guest')}
                  </a>
                </div>
              </form>
            </div>
            </div>
          </div>
        </div>
      </div>
);
};

export default LoginFormBackend;
